export const getInitials = (user) => {
  const first = user && user.firstname ? user.firstname.charAt(0) : "";
  const initials = first.toUpperCase()
  return initials;
};
